import React from 'react';
import { Card, CardContent, Typography, Box, Avatar } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import { styled } from '@mui/material/styles';

const getCardColor = (title) => {
  // Determine color based on card title
  if (title.includes('recibidas')) return { bgLight: '#e3f2fd', bgDark: '#2196f3', icon: <QuestionAnswerIcon /> };
  if (title.includes('resueltas')) return { bgLight: '#e8f5e9', bgDark: '#4caf50', icon: <AutoFixHighIcon /> };
  if (title.includes('derivadas')) return { bgLight: '#fff8e1', bgDark: '#ffc107', icon: <MarkEmailReadIcon /> };
  if (title.includes('éxito')) return { bgLight: '#ede7f6', bgDark: '#673ab7', icon: <ThumbUpAltIcon /> };
  
  // Default color if no match
  return { bgLight: '#e3f2fd', bgDark: '#2196f3', icon: <QuestionAnswerIcon /> };
};

const StyledCard = styled(Card)(({ theme, bglight }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.shape.borderRadius,
  boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.05), 0px 1px 10px 0px rgba(0,0,0,0.025)',
  background: `linear-gradient(135deg, ${bglight || '#e3f2fd'} 0%, #ffffff 100%)`,
  border: 'none',
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: '0px 4px 8px -1px rgba(0,0,0,0.1), 0px 2px 12px 0px rgba(0,0,0,0.05)'
  }
}));

const IconAvatar = styled(Avatar)(({ theme, bgcolor }) => ({
  backgroundColor: bgcolor || theme.palette.primary.main,
  color: '#fff',
  width: 48,
  height: 48,
  marginBottom: theme.spacing(1.5)
}));

const KpiCard = ({ title, value, unit, description, change }) => {
  const hasChange = change !== undefined;
  const isPositive = hasChange && change >= 0;
  
  const { bgLight, bgDark, icon } = getCardColor(title);
  
  return (
    <StyledCard bglight={bgLight}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconAvatar bgcolor={bgDark}>
            {icon}
          </IconAvatar>
          <Typography variant="subtitle1" color="text.secondary" sx={{ ml: 2, lineHeight: 1 }}>
            {title}
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 1 }}>
          <Typography component="div" variant="h3" color="text.primary" sx={{ fontWeight: 600 }}>
            {value}
          </Typography>
          {unit && (
            <Typography variant="subtitle1" color="text.secondary" sx={{ ml: 1, mb: 0.5 }}>
              {unit}
            </Typography>
          )}
          {hasChange && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                ml: 2,
                color: isPositive ? 'success.main' : 'error.main',
              }}
            >
              {isPositive ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              <Typography
                variant="body2"
                component="span"
                sx={{ color: isPositive ? 'success.main' : 'error.main' }}
              >
                {Math.abs(change)}%
              </Typography>
            </Box>
          )}
        </Box>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </CardContent>
    </StyledCard>
  );
};

export default KpiCard; 